export default __webpack_public_path__ + "static/media/Thug's Leggings of Shattered Souls.76b16d03.jpg";